import script from "./user-identification-legal.vue?vue&type=script&lang=ts&setup=true"
export * from "./user-identification-legal.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__